import { render, staticRenderFns } from "./centCommissionDetails.vue?vue&type=template&id=b7f97d10&"
import script from "./centCommissionDetails.vue?vue&type=script&lang=js&"
export * from "./centCommissionDetails.vue?vue&type=script&lang=js&"
import style0 from "./centCommissionDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports